module.exports = __webpack_public_path__ + "static/media/CC_NZ_2nd_video_screen.7166705a.png";